import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class StatesService {
  private statesUrl = 'assets/states.json';

  constructor(private http: HttpClient) {}

  getStates(): Observable<any> {
    return this.http.get<any>(this.statesUrl);
  }
}
